// src/components/shop/ProductTabSpecification.jsx

import React from 'react';
import PropTypes from 'prop-types';

function ProductTabSpecification({ characteristics }) {
  // Normalize incoming data:
  // — if it's an array, use it directly;
  // — if it's an object with .list, use that;
  // — otherwise, fall back to empty array.
  const specs = Array.isArray(characteristics)
    ? characteristics
    : characteristics && Array.isArray(characteristics.list)
    ? characteristics.list
    : [];

  return (
    <div className="spec">
      <h3 className="spec__header">Характеристики</h3>
      <div className="spec__section">
        <h4 className="spec__section-title">Основные</h4>
        {specs.map((feature, index) => (
          <div key={index} className="spec__row">
            <div className="spec__name">{feature.name}</div>
            <div className="spec__value">{feature.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

ProductTabSpecification.propTypes = {
  // может быть просто массив {name,value} или объект { list: [ {name,value}, ... ] }
  characteristics: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    PropTypes.shape({
      list: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          value: PropTypes.string,
        })
      ),
    }),
  ]),
};

ProductTabSpecification.defaultProps = {
  characteristics: [],
};

export default ProductTabSpecification;
